




























import { Vue, Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { replaceUrl } from '~/utils/explorer.js';

import {
  title as bikeTitle,
  content as bikeContent,
  appTitle as bikeApp,
} from '~/static/content/universes/bike.js';

import {
  title as skiTitle,
  content as skiContent,
  appTitle as skiApp,
} from '~/static/content/universes/ski.js';

import {
  title as nordicTitle,
  content as nordicContent,
  appTitle as nordicApp,
} from '~/static/content/universes/nordic.js';

import {
  title as trailTitle,
  content as trailContent,
  appTitle as trailApp,
} from '~/static/content/universes/trail.js';

import MarkdownContainer from '~/components/partials/MarkdownContainer.vue';
import UniversesAppCard from '~/components/cards/UniversesAppCard.vue';

@Component({
  components: { UniversesAppCard, MarkdownContainer },
  middleware: [
    'noauth',
  ],
  computed: {
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.content.match(new RegExp('<p>' + "(.*)" + '</p>'));
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.title} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.title} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `https://www.onpiste.com${self.getBannerImage()}`,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}universes/${self.$slugify(self.title)}-${self.universeId}`,
        },
      ],
    };
  },
  fetch () {
    const self: any = this;
    if (
      self.$route.params.universeid.split('-').pop() === '' ||
      isNaN(Number(self.$route.params.universeid.split('-').pop()?.trim()))
    ) {
      return self.$nuxt.error({
        statusCode: 404,
        response: { data: { detail: 'Unknown universe' } },
      });
    } else {
      self.getElements();
    }
  },
})
export default class About extends Vue {
  locale: string;
  title: string = '';
  content: string = '';
  appTitle: string = '';

  /* Returns ID contained in URL */
  get universeId () {
    return this.$route.params.universeid.split('-').pop()?.trim();
  }

  /* This method retrieves the right local content based on store locale */
  @Watch('locale')
  getElements () {
    const title: {[key: string]: string} = this.getTitle();
    this.title = title[this.locale] || title['en'];

    const content: {[key: string]: string} = this.getContent();
    this.content = content[this.locale] || content['en'];

    const appTitle: {[key: string]: string} = this.getAppTitle();
    this.appTitle = appTitle[this.locale] || appTitle['en'];
  }

  mounted () {
    /*
      Using util method to adapt URL to a specific format containing title and
      ID of retrieved element for better SEO.
    */
    replaceUrl(
      this.$route.params.universeid,
        `${this.locale !== 'fr' ? `/${this.locale}` : ''}/universes/${this.$slugify(this.title)}`,
        this.$slugify(this.title),
    );
  }

  /* Switch to return right asset based on universe ID */
  getImage () {
    switch (this.universeId) {
      case '0': return '/img/universes/ski.jpg';
      case '1': return '/img/universes/trail.jpg';
      case '2': return '/img/universes/marche_nordique.jpg';
      case '3': return '/img/universes/velo.jpg';
      default: return '/img/universes/ski.jpg';
    }
  }

  /* Switch to return right asset based on universe ID */
  getBannerImage () {
    switch (this.universeId) {
      case '0': return '/img/universes/ski_banner.jpg';
      case '1': return '/img/universes/trail_banner.jpg';
      case '2': return '/img/universes/marche_nordique_banner.jpg';
      case '3': return '/img/universes/velo_banner.jpg';
      default: return '/img/universes/ski_banner.jpg';
    }
  }

  /* Switch to return right translated title based on universe ID */
  getTitle () {
    switch (this.universeId) {
      case '0': return skiTitle;
      case '1': return trailTitle;
      case '2': return nordicTitle;
      case '3': return bikeTitle;
      default: return skiTitle;
    }
  }

  /* Switch to return right translated content based on universe ID */
  getContent () {
    switch (this.universeId) {
      case '0': return skiContent;
      case '1': return trailContent;
      case '2': return nordicContent;
      case '3': return bikeContent;
      default: return skiContent;
    }
  }

  /* Switch to return right translated text based on universe ID */
  getAppTitle () {
    switch (this.universeId) {
      case '0': return skiApp;
      case '1': return trailApp;
      case '2': return nordicApp;
      case '3': return bikeApp;
      default: return skiApp;
    }
  }
}
